import { render, staticRenderFns } from "./BigDevice.vue?vue&type=template&id=303c531c&scoped=true&"
import script from "./BigDevice.vue?vue&type=script&lang=js&"
export * from "./BigDevice.vue?vue&type=script&lang=js&"
import style0 from "./BigDevice.vue?vue&type=style&index=0&id=303c531c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "303c531c",
  null
  
)

export default component.exports